/**
 * @doc https://www.notion.so/Permissions-tables-023baaeda4744d2487b31103894c3502
 */
export const PermissionAbilityEnum = {
  can: 'can',
  cannot: 'cannot',
} as const;
export type PermissionAbilityEnum =
  (typeof PermissionAbilityEnum)[keyof typeof PermissionAbilityEnum];
